import { useState, useEffect } from "react";
import { IconButton } from "@chakra-ui/react";
import {
    isFavorite as isFavoriteState,
} from '../../utils/cookie-utils';

const FavoriteButton = ({ eventId, isFavorite = isFavoriteState(eventId), onChange, variant = 'overlay' }) => {
    const [favorite, setFavorite] = useState(isFavorite);

    useEffect(() => {
        setFavorite(isFavorite);
    }, [isFavorite]);

    const toggle = () => {
        const newState = !favorite;
        setFavorite(newState);
        onChange?.(eventId, newState);
    };

    if (variant === 'light') {
        // Wersja na jasne tło (nagłówek strony wydarzenia)
        return (
            <IconButton
                onClick={toggle}
                aria-label="Ulubione"
                aria-pressed={favorite}
                borderRadius="full"
                w={{ base: '44px', md: '48px' }}
                h={{ base: '44px', md: '48px' }}
                minW={{ base: '44px', md: '48px' }}
                bg={favorite ? 'brand.500' : 'white'}
                border="1px solid"
                borderColor={favorite ? 'brand.500' : 'surface.control'}
                color={favorite ? 'white' : 'ink.900'}
                _hover={{ bg: favorite ? 'brand.600' : 'surface.page' }}
                icon={<svg width="20" height="20" viewBox="0 0 24 24" fill={favorite ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"></path></svg>}
            />
        );
    }

    return (
        <button onClick={toggle} style={{height: '32px'}}>
            {favorite ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.75" y="0.75" width="30.5" height="30.5" rx="15.25" fill="#7A1F35"/>
                    <rect x="0.75" y="0.75" width="30.5" height="30.5" rx="15.25" stroke="white" stroke-width="1.5"/>
                    <path d="M10.0251 11.0294C9.70013 11.3558 9.44232 11.7433 9.26642 12.1697C9.09053 12.5961 9 13.0532 9 13.5147C9 13.9763 9.09053 14.4333 9.26642 14.8598C9.44232 15.2862 9.70013 15.6736 10.0251 16L16 22L21.9749 16C22.6313 15.3409 23 14.4469 23 13.5147C23 12.5826 22.6313 11.6886 21.9749 11.0294C21.3185 10.3703 20.4283 10 19.5 10C18.5717 10 17.6815 10.3703 17.0251 11.0294L16 12.0589L14.9749 11.0294C14.6499 10.7031 14.2641 10.4442 13.8394 10.2675C13.4148 10.0909 12.9596 10 12.5 10C12.0404 10 11.5853 10.0909 11.1606 10.2675C10.736 10.4442 10.3501 10.7031 10.0251 11.0294Z" fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                : <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.75" y="0.75" width="30.5" height="30.5" rx="15.25" stroke="white" stroke-width="1.5"/>
                <path d="M9.17159 10.201C8.80015 10.5818 8.50551 11.0338 8.30449 11.5313C8.10346 12.0288 8 12.562 8 13.1005C8 13.639 8.10346 14.1722 8.30449 14.6697C8.50551 15.1672 8.80015 15.6193 9.17159 16L16 23L22.8284 16C23.5786 15.231 24 14.188 24 13.1005C24 12.013 23.5786 10.97 22.8284 10.201C22.0783 9.43203 21.0609 9.00001 20 9.00001C18.9391 9.00001 17.9217 9.43203 17.1716 10.201L16 11.402L14.8285 10.201C14.457 9.82025 14.0161 9.51821 13.5308 9.31214C13.0455 9.10606 12.5253 9 12 9C11.4747 9 10.9546 9.10606 10.4693 9.31214C9.98398 9.51821 9.54302 9.82025 9.17159 10.201Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>}
        </button>
    );
};
export default FavoriteButton;
